var map = {
	"./checkout.png": "f9eb",
	"./dashboard-logo-bg.png": "f162",
	"./dashboard.png": "461b",
	"./fonts/DIN-Next-Rounded/1120eb10-bbb9-40ce-8295-69fe28a06b68.woff2": "cc0a",
	"./fonts/DIN-Next-Rounded/414aac2b-b155-4948-8733-ca83f707714f.eot": "c4eb",
	"./fonts/DIN-Next-Rounded/6b52da97-62cc-435e-9602-a010041892ca.eot": "60b9",
	"./fonts/DIN-Next-Rounded/8436c5b3-8af1-40f9-acd7-48dfdcaeac50.woff2": "ee18",
	"./fonts/DIN-Next-Rounded/97252acf-16d3-480c-8269-89ea815e4179.woff": "64b1",
	"./fonts/DIN-Next-Rounded/b03c5cd2-c6ad-4764-9cab-bf6211f181a7.woff": "6245",
	"./fonts/DIN-Next-Rounded/e06f8fa7-aeda-4810-967e-0fd3d4621441.ttf": "dc60",
	"./fonts/DIN-Next-Rounded/fb4860e4-3e80-46aa-92f9-63d03e5db476.ttf": "a59a",
	"./fonts/catamaran/Catamaran-Black.woff": "4939",
	"./fonts/catamaran/Catamaran-Black.woff2": "4d0d",
	"./fonts/catamaran/Catamaran-Bold.woff": "80b4",
	"./fonts/catamaran/Catamaran-Bold.woff2": "1b83",
	"./fonts/catamaran/Catamaran-ExtraLight.woff": "da0c",
	"./fonts/catamaran/Catamaran-ExtraLight.woff2": "097a",
	"./fonts/catamaran/Catamaran-Medium.woff": "4c2a",
	"./fonts/catamaran/Catamaran-Medium.woff2": "43cf",
	"./fonts/catamaran/Catamaran-Regular.woff": "cdee",
	"./fonts/catamaran/Catamaran-Regular.woff2": "881e",
	"./fonts/source-sans-pro/Source-Sans-Pro-Bold.woff": "400d",
	"./fonts/source-sans-pro/Source-Sans-Pro-Bold.woff2": "53c8",
	"./fonts/source-sans-pro/Source-Sans-Pro-Regular.woff": "1084",
	"./fonts/source-sans-pro/Source-Sans-Pro-Regular.woff2": "4cd6",
	"./fonts/unicons/unicons.eot": "9ef9",
	"./fonts/unicons/unicons.ttf": "8402",
	"./fonts/unicons/unicons.woff": "bb99",
	"./fonts/unicons/unicons.woff2": "f683",
	"./footer-bg-2.png": "5d11",
	"./footer-bg.png": "4ef4",
	"./hero-man.png": "1979",
	"./home-bg.jpg": "31ae",
	"./home-robotarm.png": "fd4a",
	"./home-robotarm.svg": "c56e",
	"./home-spaceship.svg": "cfdf",
	"./home-video-bg.jpg": "4d49",
	"./logo-dark.png": "b68a",
	"./logo.png": "cf05",
	"./mastercard-world.png": "2c37",
	"./mountains-bg.png": "7fc8",
	"./multicurrency.png": "111a",
	"./pos.png": "c318",
	"./processing.png": "16da",
	"./profile.png": "c3e7",
	"./rocks.png": "7e6d",
	"./security.png": "58ca",
	"./tutorial-thumbnail.png": "d8d9",
	"./vid/home-bg.mp4": "0ff4",
	"./vid/home-video-bg.mp4": "5892",
	"./working-man.png": "caae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";